module.exports = __webpack_public_path__ + "img/leucemie-espoir.6afc0be7.jpg";